import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const CompanyPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Company}
        fetchRecordsUrl={AdminReqUrls.admin__company__mainPage_fetch_recordList}
        requestOptions={{fetchImages: true}}
    />)
});
export default CompanyPage;
